import alt from '../alt';

class modalAction {
    constructor() {
        this.generateActions(
            'modalContent',   
            'modalClose',  
        );
    }
}
export default alt.createActions(modalAction);


// WEBPACK FOOTER //
// ./app/actions/modalAction.js